
import { defineComponent } from 'vue';
import Common from './Common.vue';
export default defineComponent({
    extends: Common,
    computed:{
        videoWidth(): string{
            return '100%';
        },
        showArrows(): boolean{
            return true;
        }
    }
});
